import React from 'react';
import { Row, Container, Col } from "react-bootstrap";
import {
  BuildIcon,
  DesignIcon,
  LaunchIcon,
  MaintenanceIcon,
  PlaneIcon,
  TestIcon,
} from "../../../app-constants";
const WorkFlow = [
  {
    logo: PlaneIcon,
    title: "Plan",
    description:
      "We use scrum methodologies to construct a path for development prioritizing items from the backlog.",
    count: "01",
  },
  {
    logo: DesignIcon,
    title: "Design",
    description:
      "We craft a user-friendly and visually appealing user interface in this phase.",
    count: "02",
  },
  {
    logo: BuildIcon,
    title: "Build",
    description:
      "We craft a user-friendly and visually appealing user interface in this phase.",
    count: "03",
  },
  {
    logo: TestIcon,
    title: "Test",
    description:
      "To ensure your app works accurately on multiple platforms, rigorous testing is conducted to identify and rectify any bugs.",
    count: "04",
  },
  {
    logo: LaunchIcon,
    title: "Launch",
    description:
      "Your mobile app is ready to make its debut in various stores, reaching its intended audience.",
    count: "05",
  },
  {
    logo: MaintenanceIcon,
    title: "Maintenance",
    description:
      "We offer continuing support and upgrades to keep your software up to date and responsive to your requirements.",
    count: "06",
  },
];
const Workflow = () => {
  return (
    <div className="workflow p-100 tekrevol_gray_bg">
      <Container>
        <Row>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <h2>
              Our Custom Software Development <span>Workflow</span>
            </h2>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <p>
              We use a systematic technique to tackle tasks of various complexity with precision. As your trusted custom software development agency, we embrace a modified process, ensuring your product reflects the uniqueness of your innovative and progressive ideas.
            </p>
          </Col>
        </Row>
        <Row className="workflow_secion">
          {WorkFlow.map((item, index) => (
            <Col xs={12} md={6} lg={4} xl={4} xxl={4} className="my-auto">
              <div className="workflow_items">
                <div className="item_name">
                  <span>{item.count}</span>
                  {item.title}
                  <div className="item_icon"> {item.logo}</div>
                </div>
                <p>{item.description}</p>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
};

export default Workflow;
